import { MaplibreLayer } from "mobility-toolbox-js/ol";

import { BaseLayerDescriptor } from "../envConfig";

/**
 * Creates an array of MapboxLayer objects from a config object and some global values.
 * baseLayersConfig = {
 *   'basemap': {
 *     visible: true,
 *     style: 'base_bright_v2',
 *     tilesUrl: import.meta.env.VITE_VECTOR_TILES_URL,
 *     thumbnail: path/to/thumbnail.png,
 *   }
 * }
 */
function createBaseLayers(
  baseLayersConfig: BaseLayerDescriptor[],
  { tilesKey, tilesUrl }: { tilesKey?: string; tilesUrl?: string } = {},
) {
  return baseLayersConfig.map(
    ({ key, name, style, thumbnail, url, visible }) => {
      return new MaplibreLayer({
        apiKey: tilesKey,
        isBaseLayer: true,
        key,
        mapOptions: {
          canvasContextAttributes: {
            maxCanvasSize: [Infinity, Infinity], // very important otherwise canvas limited to 4096x4096
          },
        },
        name,
        style,
        thumbnail,
        url: url || tilesUrl,
        visible: !!visible,
        zIndex: -1,
      });
    },
  );
}

export default createBaseLayers;
